export default __webpack_public_path__ + "static/media/customer_red.a178e006.svg";